import { updateAppSubModule } from "../api/appModuleService";

export const useUpdateSubModule = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateAppSubModule(id, data);
        if (successCallback) successCallback();
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update app sub module:", error);
        throw error;
    }
  };

  return { update };
};